import ShopInfo from './shop_info.vue'

export default {
    path: 'shopInfo',
    component: ShopInfo
}
